<div [ngClass]="{ 'has-edit-button': page.isPreview() }">
  <!-- edit button -->
  <ng-container
    *ngIf="page.isPreview()"
    [brManageContentButton]="document"
    parameter="document"
    [relative]="false"
    documentTemplateQuery="new-PageSection-document"
    folderTemplateQuery="new-PageSection-folder"
    root=""
  >
  </ng-container>

  <!-- Has document (Dynamically load component) -->
  <div
    [class.debug-mode]="debugMode"
    [style.opacity]="!document ? '0.8' : '1'"
    [id]="content?.sectionId"
    [edsSpacing]="marginBottom === 'auto' ? 'xl' : marginBottom"
  >
    <ng-template #dynamicCmp></ng-template>

    <!-- DEBUG PADDING -->
    <span
      *ngIf="debugMode"
      [ngStyle]="{
        background: 'green',
        color: 'white',
        position: 'absolute',
        bottom: 'top',
        display: 'block',
        padding: '1rem'
      }"
      >Page Section : {{ marginBottom ? marginBottom : "xxxl" }}</span
    >
    <!-- / DEBUG PADDING -->
  </div>

  <!-- No Section Type defined -->
  <div
    *ngIf="document && page.isPreview() && !sectionType"
    class="no-document"
    edsPadding
  >
    <div class="no-document__component">
      <div class="no-document__overlay">
        Click to configure <strong>Section Type</strong>
      </div>
    </div>
  </div>

  <!-- No Content && Preview (Currently redundant) -->
  <div *ngIf="!content && page.isPreview()" class="no-document" edsPadding>
    <div class="no-document__component">
      <div class="no-document__overlay">
        Click to configure <strong>Page Section</strong>
      </div>
    </div>
  </div>
</div>
